<template>
  <div>
      <vue-tree-navigation :items="items" />
  </div>
</template>
}
<script>
import VueTreeNavigation from 'vue-tree-navigation'
Vue.use(VueTreeNavigation)

export default {
  
  props: {
      explorableid:''
  },
  
  data() {
    return {
      items: [
        { name: 'Welcome', path: '/' + this.manyExplorables(), children: [
          { name: '1. Introduction', path: 'introduction' },
          { name: '2. Theory', path: 'theory', children: [
              { name: 'Extraversion/Introversion', path: 'EI', children: [
                { name: 'Participate', element: '#Participate' },
                { name: 'Energize', element: '#Energize' },
                { name: 'Learn', element: '#Learn' },
              ]},
              { name: 'Sensing/iNtuition', path: 'SN', children: [
                { name: 'Grasp', element: '#Grasp' },
                { name: 'See', element: '#See' },
                { name: 'Like', element: '#Like' },
              ]},
              { name: 'Thinking/Feeling', path: 'TF', children: [
                { name: 'Defend', element: '#Defend' },
                { name: 'Seek', element: '#Seek' },
                { name: 'Decide', element: '#Decide' },
              ]},
              { name: 'Judging/Perceiving', path: 'JP', children: [
                { name: 'Work', element: '#Work' },
                { name: 'Choose', element: '#Choose' },
                { name: 'Trust', element: '#Trust' },
              ]},
            ]},
          { name: '3. Mandala', path: 'mandala' },
          { name: '4. Gallery', path: 'gallery', children: [
            { name: 'ESFP', path: 'ESFP', class:'green', children: [
              { name: 'It\'s Not Work', element: 'itsnotwork' },
              { name: 'Learn By Doing', element: 'learnbydoing' },
              { name: 'A Big Exchange of Energy', element: 'abigexchange' },
              { name: 'A Big Exchange of Energy 2', element: 'abigexchange2' },
              { name: 'Sensing', element: 'sensing' },
              { name: 'Nature', element: 'nature' },
              { name: 'Oil Paint', element: 'oilpaint' },
              { name: 'Clarity', element: 'clarity' },
              { name: 'Choosing to Work', element: 'choosingtowork' },
              { name: 'Everyone is Unique', element: 'everyoneisunique' },
              { name: 'Without Inhibition', element: 'withoutinhibition' },
              { name: 'My Ideal', element: 'myideal' },
              { name: 'Curiosity', element: 'curiosity' },
              { name: 'Take it Easy!', element: 'takeiteasy' },
              { name: 'I Don\'t Paralyze', element: 'paralyze' },
              { name: 'I Can\'t Resist', element: 'resist' },
            ]},
            { name: 'ISFJ', path: 'ISFJ', children: [
              { name: 'What I Stand For', element: 'what' },
              { name: 'Equilibrium', element: 'equilibrium' },
              { name: 'Introverted Sensing', element: 'introvertedsensing' },
              { name: 'Total Recall', element: 'totalrecall' },
              { name: 'Getting to the Best of Me', element: 'getting' },
              { name: 'The (Entirely Free) Clutter Sermon', element: 'entirely' },
              { name: 'Always', element: 'going' },
            ]},
            { name: 'ESTP', path: 'ESTP', children: [
              { name: 'Without Inhibition', element: 'without' },
              { name: 'Flying High', element: 'flying' },
              { name: 'A Reason to Collect', element: 'areason' },
              { name: 'Knowing Just What To Do', element: 'knowing' },
              { name: 'Gardening', element: 'gardening' },
              { name: 'More Knowing Just What To Do', element: 'moreknowing' },
              { name: 'Whatever\'s at Hand', element: 'whatevers' },
              { name: 'Dumpsters and Skips', element: 'dumpsters' },
              { name: 'Sheds & Things', element: 'sheds' },
              { name: 'Curiosity', element: 'curiosity' },
            ]},
            { name: 'ISTJ', path: 'ISTJ', children: [
              { name: 'A Laborious Process', element: 'laborious' },
              { name: 'Impressions', element: 'impressions' },
              { name: 'Details', element: 'details' },
              { name: 'The Human Daytimer', element: 'humandaytimer' },
              { name: 'Uncluttered Spaces', element: 'uncluttered' },
              { name: 'Problem-Solving', element: 'problemsolving' },
              { name: 'Seeing the Future', element: 'seeing' },
              { name: 'The Dividends of Self-Knowledge', element: 'dividends' },
              { name: 'ISTJ and ISFJ At Work', element: 'atwork' },
              { name: 'Type Distributions', element: 'typedistributions' },
              { name: 'Top Three Descriptors', element: 'topthree' },
            ]},
            { name: 'ENTP', path: 'ENTP', children: [
              { name: 'Words', element: 'words' },
              { name: 'Time', element: 'time' },
              { name: 'Once Started', element: 'oncestarted' },
              { name: 'Radars and Lightning', element: 'radars' },
              { name: 'It\'s Like', element: 'itslike' },
              { name: 'Possibilities', element: 'possibilities' },
              { name: 'Restless', element: 'restless' },
              { name: 'Patterns', element: 'patterns' },
            ]},
            { name: 'INTJ', path: 'INTJ', children: [
              { name: 'Thinking', element: 'thinking' },
              { name: 'Thinking 2', element: 'thinking2' },
              { name: 'Stretch Minds into the 4th Dimension', element: 'stretchminds' },
            ]},
            { name: 'ENFP', path: 'ENFP', children: [
              { name: 'Self-Actualization', element: 'selfactualization' },
              { name: 'It\'s Like', element: 'itslike' },
              { name: 'Endless', element: 'endless' },
              { name: 'Originality', element: 'originality' },
              { name: 'The Great Pretender', element: 'thegreatpretender' },
              { name: 'Nebulous', element: 'nebulous' },
              { name: 'I Want It All', element: 'iwant' },
              { name: 'Possibilities', element: 'possibilities' },
              { name: 'It\'s Magical', element: 'itsmagical' },
              { name: 'Inner Self', element: 'innerself' },
            ]},
            { name: 'INFJ', path: 'INFJ', children: [
              { name: 'The Forgotten Ones', element: 'theforgottenones' },
              { name: 'Running on a Dream', element: 'running' },
              { name: 'A Bucket of Eels', element: 'abucket' },
              { name: 'Practical Mysticism', element: 'practical' },
              { name: 'Wordless Communication', element: 'wordless' },
              { name: 'The Whole World', element: 'thewhole' },
            ]},
            { name: 'ESTJ', path: 'ESTJ', children: [
              { name: 'Thinking', element: 'thinking' },
              { name: 'Sensing', element: 'sensing' },
              { name: 'Words', element: 'words' },
              { name: 'Vulnerability', element: 'vulnerability' },
            ]},
            { name: 'ISTP', path: 'ISTP', children: [
              { name: 'What is Difficult', element: 'whatisdifficult' },
              { name: 'Thinking is Like', element: 'thinkingislike' },
              { name: 'Categories', element: 'categories' },
              { name: 'Definitions', element: 'definitions' },
              { name: 'Sensing', element: 'Sensing' },
              { name: 'Guidelines', element: 'guidelines' },
            ]},
            { name: 'ENTJ', path: 'ENTJ', children: [
              { name: 'Thinking', element: 'thinking' },
              { name: 'Intuition', element: 'intuition' },
              { name: 'Communication', element: 'communication' },
              { name: 'Caring', element: 'caring' },
              { name: 'A License to be Human', element: 'license' },
              { name: 'Thinking all the Way', element: 'being' },
              { name: 'Always in Action', element: 'going' },
            ]},
            { name: 'INTP', path: 'INTP', children: [
              { name: 'Timelines', element: 'timelines' },
              { name: 'Mental Mytosis', element: 'mentalmytosis' },
              { name: 'Compentence', element: 'compentence' },
              { name: 'Introversion', element: 'introversion' },
              { name: 'Models', element: 'models' },
            ]},
            { name: 'ESFJ', path: 'ESFJ', children: [
              { name: 'People', element: 'people' },
              { name: 'Feeling Is', element: 'feelingis' },
              { name: 'Validation', element: 'validation' },
              { name: 'Ideals', element: 'ideals' },
              { name: 'Feeling Connected', element: 'feelingconnected' },
              { name: 'Feeling is Like', element: 'feelingislike' },
              { name: 'Nothing More Important', element: 'nothingmore' },
              { name: 'With or Without Harmony', element: 'withorwithoutharmony' },
              { name: 'Tell Your Face', element: 'tellyourface' },
              { name: 'So Much Caretaking', element: 'somuchcare' },
              { name: 'Pain', element: 'pain' },
              { name: 'How Do We Know', element: 'howdoweknow' },
              { name: 'How Are We Different?', element: 'howarewe' },
              { name: 'Why Are We Together?', element: 'whyarewe' },
            ]},
            { name: 'ISFP', path: 'ISFP', children: [
              { name: 'Being Feeling', element: 'beingfeeling' },
              { name: 'Sensing Intuition', element: 'sensingintuition' },
              { name: 'Without Boundaries', element: 'withoutboundaries' },
              { name: 'Be Happy', element: 'behappy' },
              { name: 'Words', element: 'words' },
            ]},
            { name: 'ENFJ', path: 'ENFJ', children: [
              { name: 'People', element: 'people' },
              { name: 'Feeling Is', element: 'feelingis' },
              { name: 'Validation', element: 'validation' },
              { name: 'Ideals', element: 'ideals' },
              { name: 'Not With a Stranger', element: 'notwith' },
              { name: 'Communication', element: 'communication' },
              { name: 'Feeling Connected', element: 'feelingconnected' },
              { name: 'Feeling is Like', element: 'feelingislike' },
              { name: 'Nothing More Important', element: 'nothingmore' },
              { name: 'With or Without Harmony', element: 'withorwithoutharmony' },
              { name: 'Tell Your Face', element: 'tellyourface' },
              { name: 'So Much Caretaking', element: 'somuchcare' },
              { name: 'How Are We Different?', element: 'howarewe' },
              { name: 'Why Are We Together?', element: 'whyarewe' },
              { name: 'Pain', element: 'pain' },
              { name: 'How Do We Know', element: 'howdoweknow' },
            ]},
            { name: 'INFP', path: 'INFP', children: [
              { name: 'Understanding INFP', element: 'understandinginfp' },
              { name: 'Values', element: 'values' },
              { name: 'Emotions', element: 'Emotions' },
              { name: 'Cottage Cheese for Christmas', element: 'cottagecheese' },
              { name: 'All Deaths', element: 'alldeaths' },
              { name: 'Remembering', element: 'remembering' },
              { name: 'Sea Lotus', element: 'sealotus' },
            ]},
        ]},
        { name: '5. Treelogy', path: 'treelogy', children: [
              { name: 'Sensing & Thinking', path: 'ST' },
              { name: 'Extraverted Thinking', path: 'ET' },
              { name: 'Intuition & Thinking', path: 'NT' },
              { name: 'Introverted Thinking', path: 'IT' },
              { name: 'Extraverted Sensing', path: 'ES' },
              { name: 'Introverted Sensing', path: 'IS' },
              { name: 'Seeds of Wisdom', path: 'wisdom' },
              { name: 'Introverted Intuition', path: 'IN' },
              { name: 'Extraverted Intuition', path: 'EN' },
              { name: 'Introverted Feeling', path: 'IF' },
              { name: 'Extraverted Feeling', path: 'EF' },
              { name: 'Sensing & Feeling', path: 'SF' },
              { name: 'Intuition & Feeling', path: 'NF' },
            ]},
        { name: '6. What\'s Next', path: 'whatsnext' },
        // { name: 'Resources', path: 'resources' },
        ]},
      ],
    };
  },
  methods: {
    manyExplorables() {
      if (this.explorableid) {
        return 'explore/' + this.explorableid + '/magnificent16';
      }
      else {
        return 'explore/magnificent16';
      }
    }
  },
};
</script>